// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__1-7Z_","name":"style_name__2Zkpg","price":"style_price__3ItzS","addBtn":"style_addBtn__3M0LL","itemImg":"style_itemImg__1HbHK"};